import { createRiskContributorsQuery } from "./risk"
import { createDrilldownContributorsQuery } from "./drilldown-helpers"
import { createDrilldownBaseGatherers, type DrilldownBaseGathererOptions } from "./drilldown-base"
import type { ContributorsQueryOptions } from "./contributors-query-types"

export function createDrilldownRiskContributorsQuery({
  selectedFactor,
  ...options
}: ContributorsQueryOptions) {
  const factorIds = selectedFactor ? [selectedFactor] : []
  return createDrilldownContributorsQuery(createRiskContributorsQuery, factorIds, options)
}

export function createRiskDrilldownGatherers({
  endDate,
  startDate,
  selectedFactor,
  classifications,
  instrumentSuffix = "",
  ...coreOptions
}: DrilldownBaseGathererOptions & { selectedFactor?: string }) {
  const baseGatherers = createDrilldownBaseGatherers({
    ...coreOptions,
    endDate,
    startDate,
    classifications,
    instrumentSuffix,
  })
  const riskGatherer = createDrilldownRiskContributorsQuery({
    ...coreOptions,
    prefix: `risk${instrumentSuffix}`,
    to: endDate,
    selectedFactor,
  })
  return [...baseGatherers, riskGatherer]
}
